import { defineStore } from 'pinia'
import { db } from '~/service/firebase_config'
import { filterTemplate } from '~~/utils/filterTemplate'

import { doc, getDoc, onSnapshot, setDoc } from 'firebase/firestore'

import _map from 'lodash/map.js'
import _find from 'lodash/find.js'
import _forEach from 'lodash/forEach.js'
import _concat from 'lodash/concat.js'
import _sample from 'lodash/sample.js'
import _sampleSize from 'lodash/sampleSize.js'
import _cloneDeep from 'lodash/cloneDeep.js'
import _uniq from 'lodash/uniq.js'
import _uniqBy from 'lodash/uniqBy.js'
import _includes from 'lodash/includes.js'
import _filter from 'lodash/filter.js'
import _take from 'lodash/take.js'
import { useEventStore } from './event'
import { useWishStore } from './wish'
import FontFaceObserver from 'fontfaceobserver'
import Konva from 'konva'

import delay from '~/utils/delay'
import { useUploadStore } from './upload'
import { mappingTemplateId } from '~/utils/mappingTemplateId'
import { useAppStateStore } from './appState'
import defaultTemplates from '~/public/data/templates'

export const useTemplateStore = defineStore({
  id: 'template',
  state: () => {
    return {
      templateUsedIds: [] as Array<string>, //[ $templateId... ]
      templateList: [],
      templateId: null as any,
      imageAttrs: null as any,
      template_1: null as any,
      template_2: null as any,
      template_3: null as any,
      templateUrlList: [],
      variant: 'w=500',
    }
  },
  actions: {
    async main() {
      await this.fetchTemplateList()
      this.generateRandomTemplates()
      this.registerWelcomeFont()
    },

    prepareTemplates() {
      // --------- ถ้าไม่ได้เลือกเลย ---------------
      if(this.templateUsedIds?.length === 0) {
        this.templateUsedIds = _concat(defaultTemplates.remove, defaultTemplates.standard)
      }
      //----------------------------------------

      this.templateUsedIds = _map(this.templateUsedIds, (id) => mappingTemplateId(id))

      const removebgTemplates = _filter(this.templateUsedIds, id => id.includes('remove'))
      const standardTemplates = _filter(this.templateUsedIds, id => id.includes('standard'))

      if(removebgTemplates?.length < 1) {
        const filteredRemovebgTemplates = _filter(defaultTemplates.remove, id => !_includes(this.templateUsedIds, id))
        const randomRemovebgId:any = _sample(filteredRemovebgTemplates)
        this.templateUsedIds.push(randomRemovebgId)
      }

      if(standardTemplates?.length < 2) {
        const filteredStandardTemplates = _filter(defaultTemplates.standard, id => !_includes(this.templateUsedIds, id))
        const randomStandardId:any = _sampleSize(filteredStandardTemplates, 2)
        console.log('randomStandardId -->', randomStandardId)
        this.templateUsedIds.push(...randomStandardId)
      }
    },

    fetchTemplateList() {
      const wishStore = useWishStore()
      const myWishes = wishStore.getMyWishList

      // เตรียม templateIds
      this.prepareTemplates()

      const mergeTemplates = getUniqTemplateIdList(this.templateUsedIds, myWishes)
      // console.log('mergeTemplates -->', mergeTemplates)

      const p = new Promise(async resolve => {
        const promiseList = []
        for (let index = 0; index < mergeTemplates?.length; index++) {
          const templateId = mergeTemplates[index];

          const docRef = doc(db, 'templates', templateId)
          const pm = getDoc(docRef)
          promiseList.push(pm)
        }

        const pmResponses = await Promise.all(promiseList)

        const tmpList: any = _map(pmResponses, (response) => response.data())
        const filtered = _filter(tmpList, t => t?.templateId)

        const mergeList = _concat(this.templateList, filtered)
        const uniqList = _uniqBy(mergeList, 'templateId')
        this.templateList = uniqList

        resolve(true)
      })

      return p
    },

    generateRandomTemplates() {
      // const templateList = _filter(this.templateList, t => t?.version === '3')
      const templateList = _filter(this.templateList, (item: any) => _includes(this.templateUsedIds, item?.templateId));

      const filteredTemplate = filterTemplate(templateList)
      let { standardList, removeList } = filteredTemplate

      this.template_1 = _sample(removeList)

      const takeList = _sampleSize(standardList, 2)
      this.template_2 = takeList[0]
      this.template_3 = takeList[1]

      console.log('template_1', this.template_1)
      console.log('template_2', this.template_2)
      console.log('template_3', this.template_3)
    },

    // --- prefetch ---
    prefetchImage(url: string) {
      return new Promise((resolve) => {
        let img = new Image();
        img.onload = function () {
          console.log('prefetch success: ', url)
          resolve(true)
        }
        img.crossOrigin = "Anonymous"
        img.src = url
      })
    },
    // --------------------------

    randomOneTemplateId() {
      const list = _concat(this.template_1, this.template_2, this.template_3)
      this.templateId = _sample(list)
    },

    randomNewTemplateByType(type: string) {
      const templateList = this.templateList

      const filteredTemplate = filterTemplate(templateList)
      const { standardList, removeList } = filteredTemplate

      let targetTemplate = ''

      if (type === 'template_1') {
        targetTemplate = _sample(removeList)
        this.template_1 = targetTemplate
        console.log('new random template_1: ', this.template_1)
      }

      if (type === 'template_2') {
        targetTemplate = _sample(standardList)
        this.template_2 = targetTemplate
        console.log('new random template_2: ', this.template_2)
      }

      if (type === 'template_3') {
        targetTemplate = _sample(standardList)
        this.template_3 = targetTemplate
        console.log('new random template_3: ', this.template_3)
      }
    },

    selectNewTemplateByTemplateId(type: string, newTemplateId: string) {
      if (type === 'template_1') {
        this.template_1 = newTemplateId
        console.log('new template_1: ', this.template_1)
      }

      if (type === 'template_2') {
        this.template_2 = newTemplateId
        console.log('new template_2: ', this.template_2)
      }

      if (type === 'template_3') {
        this.template_3 = newTemplateId
        console.log('new template_3: ', this.template_3)
      }
    },

    async renderEditor(elementId: string, wishData: any) {
      const eventStore = useEventStore()
      const uploadStore = useUploadStore()
      const templateId = this.templateId

      const templateData = _find(this.templateList, t => t.templateId === templateId)

      const { stage, zoomIn, zoomOut, zoomReset, exportWishData } = await useRenderEditorV3({
        container: elementId,
        template: templateData,
        wishData: wishData,
        variant: this.variant,
        guestBlobImage: uploadStore?.blobUrl || false,
      })

      return {
        stage,
        zoomIn,
        zoomOut,
        zoomReset,
        exportWishData,
      }
    },

    async renderPreview(elementId: string, wishData: any, templateTarget = null, attrs = null) {
      const eventStore = useEventStore()
      const uploadStore = useUploadStore()

      const templateId = templateTarget ? templateTarget : this.templateId
      const templateData = _find(this.templateList, t => t.templateId === templateId)

      let newWishData = wishData
      if (attrs) {
        newWishData.guest['imageAttrs'] = attrs
      }

       
      let result = null
      if (newWishData?.version === 'v3') {
        result = await useRenderTemplateV3({
          container: elementId,
          template: templateData,
          wishData: newWishData,
          variant: this.variant,
          guestBlobImage: uploadStore?.blobUrl || false
        })
      } else {
        result = await useRenderTemplateV1({
          container: elementId,
          template: templateData,
          wishData: newWishData,
          variant: this.variant,
          guestBlobImage: uploadStore?.blobUrl|| false
        })
      }

      return result?.stage || null
    },

    // ----- for test -----
    async renderTestEditorDebug(elementId: string, wishData: any) {
      const eventStore = useEventStore()
      const templateId = this.templateId

      const templateData = _find(this.templateList, (t) => {
        return t.templateId === templateId
      })

      console.log('templateData -->', templateData)

      const newWishData = {
        ...wishData,
        templateId: templateId
      }

      const { stage, zoomIn, zoomOut, zoomReset, exportWishData } = await useRenderEditorV3({
        container: elementId,
        template: templateData,
        wishData: newWishData,
        variant: this.variant
      })

      return {
        stage,
        zoomIn,
        zoomOut,
        zoomReset,
        exportWishData
      }
    },

    registerWelcomeFont() {
      const appState = useAppStateStore()
      const theme = appState?.theme
      const targetFont = theme?.fonts?.welcome || 'Callem'
      const defaultFonts = [ 
        "Callem",
        "Great Vibes",
        "Dancing Script",
        "Cookie",
        "Parisienne"
      ]
      const isDefaultFont = _filter(defaultFonts, f => f === targetFont)[0]
      if(!isDefaultFont) {
        useHead({
          link: [{ rel: 'stylesheet', href: `https://fonts.googleapis.com/css2?family=${targetFont}&display=swap`}]
        })
      }
    },
  },
  getters: {
    getTemplateData( ) {
      return (templateId) => {
         
        let templatIdMap = mappingTemplateId(templateId)
        const templateData = _find(this.templateList, t => t.templateId === templatIdMap)
        return templateData
      }
    }
  }
})

//  ----- utils -----
function getUniqTemplateIdList(templateIds: any, myWishes: any) {

  const wishedTemplateIds = _map(myWishes, w => w?.templateId)
  const mergeList = _concat(templateIds, wishedTemplateIds)

  const uniqList = _uniq(mergeList)

  return uniqList
}